var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.6,47.4L83,46.6c-1.4-0.1-2.6-1-3.1-2.4L67.5,6.7c-1-3.2-5.2-3.2-6.3,0L48.7,44.2c-0.5,1.4-1.7,2.4-3.1,2.4L8,47.4 c-3.1,0-4.4,4.3-1.9,6.3l30,24c1.1,0.9,1.6,2.4,1.2,3.8l-10.9,38c-0.9,3.2,2.5,5.8,5.1,3.9l30.9-22.7c1.1-0.8,2.6-0.8,3.8,0 l30.9,22.7c2.6,1.9,6-0.7,5.1-3.9l-10.9-38c-0.4-1.4,0.1-2.9,1.2-3.8l30-24C125.1,51.7,123.8,47.5,120.6,47.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.6e96ad30343720ea8cf5d6c7469c524a.svg";
export { ForwardRef as ReactComponent };